<template>
  <div class="staking-index">
    <div class="staking-content">
      <div class="staking-content-msg">
        <div class="staking-content-msg-logo">
          <img src="../../static/images/svg/terra.svg" class="staking-content-msg-logo-img">
          <p>
            <span>Terra Classic</span>
            <b>{{coinData.coin_type}}</b>
            <img src="../../static/images/svg/change.svg" alt="" @click="changeStaking">
          </p>
        </div>
        <ul>
          <li>
<!--            <p>{{coinData.current_rewards}}%</p>-->
            <p>N/A</p>
            <span>Nominal Yield</span>
          </li>
          <li>
            <p>5%</p>
            <span>Validator fee</span>
          </li>
          <li>
            <p>{{coinData.staking_ratio}}%</p>
            <span>Staked Ratio</span>
          </li>
          <li>
            <p>21 days</p>
            <span>Unbonding</span>
          </li>
          <li>
            <p style="font-size: 20px; margin-bottom: 16px;">
              0.01% &nbsp;&nbsp;downtime
              <br>
              5%&nbsp;&nbsp;double signing
            </p>
            <span>Slashing</span>
          </li>
        </ul>
        <div class="staking-content-msg-address">
          <div>
            <div class="staking-content-msg-address-msg" style="margin-bottom: 10px">
              <span>Validator Address:</span>
              <div>
                <p>terravaloper1qk46lk4kt4f90y4quv9mds0q26khhwdsjme29h</p>
                <img src="../../static/images/svg/copy.svg" @click="copyAddress('terravaloper1qk46lk4kt4f90y4quv9mds0q26khhwdsjme29h')">
              </div>
            </div>
            <div class="staking-content-msg-address-msg">
              <span>Validator name:</span>
              <div>
                <p>PoS Node</p>
              </div>
            </div>
          </div>
          <!-- <button @click="seeGuide">See staking guide</button> -->
        </div>
      </div>
      <div class="staking-content-about">
        <div class="staking-content-about-share">
          <a href="https://www.terra.money/" target="_blank"><img src="../../static/images/svg/weblink.svg" alt=""></a>
          <a href="https://twitter.com/terra_money" target="_blank"><img src="../../static/images/svg/twitter.svg" alt=""></a>
          <a href="https://www.coingecko.com/en/coins/terra-luna-classic" target="_blank"><img src="../../static/images/svg/coingecko.svg" alt=""></a>
        </div>
        <div class="staking-content-about-msg">
          <h3>About Terra Classic</h3>
          <div>Terra classic blockchain protocol provides global payment stability by using fiat-pegged stablecoins.Terra offers fast and affordable settlements as well as price stability and wide adoption of fiat currencies combined with censorship resistance.</div>
        </div>
      </div>

      <div class="staking-content-calculator">
        <h3>Terra Classic Rewards Calculator</h3>
        <ul>
          <li class="staking-content-calculator-left">
            <div class="staking-content-calculator-input">
              <input type="text" placeholder="Enter your Amount" v-model="amountInput" @input="replaceAmountInput">
              <div class="staking-content-calculator-coin-type-box">
                <div class="staking-content-calculator-coin-type">
                  <div class="staking-content-calculator-coin-type-selected">
                    <div>
                      <span>{{coinType[coinTypeIndex]}}</span><img src="../../static/images/svg/expand.svg">
                    </div>
                  </div>
                  <div class="staking-content-calculator-coin-type-choose collapse">
                    <div class="staking-content-calculator-coin-type-choose-list" :style="{background: index == coinTypeIndex ? '#e7e7e7' : '#FFFFFF'}" v-for="(item, index) in coinType" :key="index" @click="coinTypeIndex = index">
                      <div :style="{width:coinTypeWidth +'px'}"><span>{{item}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p v-if="coinTypeIndex === 0">{{amountRate | numFormat}} {{coinData.coin_type}}</p>
            <p v-if="coinTypeIndex === 1">$ {{amountRate | numFormat}}</p>
          </li>
          <li class="staking-content-calculator-right">
            <div class="staking-content-calculator-type-item">
              <span>Daily Earning</span>
              <div>
                <i v-if="dailyEarning >= 9999999999999">High Score!</i>
                <b v-if="dailyEarning < 9999999999999">$ {{dailyEarning | numFormat }}</b>
                <p v-if="dailyEarning < 9999999999999">{{coinDailyEarning | numFormat}} {{coinData.coin_type}}</p>
              </div>
            </div>
            <div class="staking-content-calculator-type-item">
              <span>Monthly Earning</span>
              <div>
                <i v-if="monthlyEarning >= 9999999999999">Yay! You’re rich!</i>
                <b v-if="monthlyEarning < 9999999999999">$ {{monthlyEarning | numFormat}}</b>
                <p v-if="monthlyEarning < 9999999999999">{{coinMonthlyEarning | numFormat}} {{coinData.coin_type}}</p>
              </div>
            </div>
            <div class="staking-content-calculator-type-item">
              <span>Yearly Earning</span>
              <div style="margin: 0;">
                <i v-if="yearlyEarning >= 9999999999999">WoW! So much {{coinData.coin_type}}!</i>
                <b v-if="yearlyEarning < 9999999999999">$ {{yearlyEarning | numFormat}}</b>
                <p v-if="yearlyEarning < 9999999999999">{{coinYearlyEarning | numFormat}} {{coinData.coin_type}}</p>
              </div>
            </div>
          </li>
        </ul>
        <div class="staking-content-calculator-tip" v-if="price !== 0">Note: It is an estimated number based on {{coinData.coin_type}} price ${{priceComputed}} and APY {{coinData.current_rewards}}%. The real data may be vary.</div>
      </div>

      <div class="staking-content-faq">
        <h3>FAQ</h3>
        <ul>
          <li>
            <div class="staking-content-faq-title">
              <p>What is the name of the asset being staked?</p>
              <img src="../../static/images/svg/expand.svg" alt="">
            </div>
            <div id="collapse1" class="staking-content-faq-content collapse">
              <p>Terra Classic Protocol's native token, LUNC, is used to stake, pay for transactions, and for validators to participate in on-chain governance.</p>
            </div>
          </li>

          <li>
            <div class="staking-content-faq-title">
              <p>What happens to the ownership of LUNC after they're delegated?</p>
              <img src="../../static/images/svg/expand.svg" alt="">
            </div>
            <div id="collapse1" class="staking-content-faq-content collapse">
              <p>You are not giving away ownership of LUNC by delegating. As a validator, PoS Node will never have the ability to move your LUNC.</p>
            </div>
          </li>

          <!-- <li>
            <div class="staking-content-faq-title">
              <p>What does PoS Node get out of this?</p>
              <img src="../../static/images/svg/expand.svg" alt="">
            </div>
            <div id="collapse1" class="staking-content-faq-content collapse">
              <p>
                We charge 5% from the block rewards received by our delegators. For example, if a delegator receives 100 LUNC as a reward, PoS Node will receive 5 LUNC while the delegator will get 95 LUNC.
              </p>
            </div>
          </li> -->

          <li>
            <div class="staking-content-faq-title">
              <p>How long does it take to unstake?</p>
              <img src="../../static/images/svg/expand.svg" alt="">
            </div>
            <div class="staking-content-faq-content collapse">
              <p>From the moment you initiate the unbonding process, it takes 21 days to unstake. During this time you will not earn rewards. When the process is complete, you can transfer/trade your LUNC tokens.</p>
            </div>
          </li>

          <li>
            <div class="staking-content-faq-title">
              <p>Can my staked LUNC be slashed?</p>
              <img src="../../static/images/svg/expand.svg" alt="">
            </div>
            <div class="staking-content-faq-content collapse">
              <p>Downtime slashing: 0.01% - when validator does not vote on at least 500 out of 10,000 latest blocks.
                <br>
                Double signing slashing: 5% - happens in case of malicious behavior, when the validator signs twice the same block to earn double rewards.
                <br>
                With PoS Node, you can be sure that you will get all your rewards as our uptime rank in all our networks equals 99.99%. The company constantly improves services and runs top-notch gear with highly professional specialists that monitor the network non-stop.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="staking-model-box" v-if="modelShow">
      <div class="staking-model">
        <p class="staking-model-close"><img src="../../static/images/svg/close.svg" alt="" @click="modelShow = false"></p>
        <div class="staking-model-msg">
          <h3>Staking Guide</h3>
          <ul>
            <li v-for="(item, index) in stakingGuideDate" :key="index" @click="toGuide(item.url)">
              <div class="staking-model-msg-img-type">
                <div>
                  <img src="../../static/images/svg/article.svg" alt="" class="staking-model-msg-type" v-if="item.type == 4">
                  <img src="../../static/images/svg/video.svg" alt="" class="staking-model-msg-type" v-if="item.type == 3">
                </div>
                <p>{{item.text}}</p>
              </div>
              <img src="../../static/images/svg/open.svg" alt="">
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  data () {
    return {
      modelShow: false,
      coinTypeWidth: 0,
      coinType: ['USD', 'LUNC'],
      coinTypeIndex: 1,
      price: 0,
      amountInput: '',
      faqIndex: -1,
      stakingGuideDate: [
        {type: 4, text: '', url: 'https://article.coinpayu.com/@Coinpayu/how-to-stake-terra-classic-lunc-on-terra-station-M6LBDDVQ'}
      ],
      coinData: {
        coin_type: 'LUNC',
        current_rewards: '',
        staking_ratio: ''
      }
    }
  },
  computed: {
    apy: function () {
      var percent = Number(parseFloat(this.coinData.current_rewards) / 100)
      return percent
    },
    priceComputed: function () {
      var percent = Math.floor(Number(this.price * 10000000)) / 10000000
      return percent
    },
    amount: function () {
      return this.amountInput.replace(/\D/g, '')
    },
    amountRate: function () {
      if (this.coinTypeIndex === 0) {
        return this.amount / this.price
      } else if (this.coinTypeIndex === 1) {
        return this.amount * this.price
      }
    },
    dailyEarning: function () {
      if (this.coinTypeIndex === 0) {
        return this.apy * this.amount / 365
      } else if (this.coinTypeIndex === 1) {
        return this.apy * this.amount * this.price / 365
      }
    },
    monthlyEarning: function () {
      if (this.coinTypeIndex === 0) {
        return this.apy * this.amount / 12
      } else if (this.coinTypeIndex === 1) {
        return this.apy * this.amount * this.price / 12
      }
    },
    yearlyEarning: function () {
      if (this.coinTypeIndex === 0) {
        return this.apy * this.amount
      } else if (this.coinTypeIndex === 1) {
        return this.apy * this.amount * this.price
      }
    },
    coinDailyEarning: function () {
      if (this.coinTypeIndex === 0) {
        return this.apy * this.amount / this.price / 365
      } else if (this.coinTypeIndex === 1) {
        return this.apy * this.amount / 365
      }
    },
    coinMonthlyEarning: function () {
      if (this.coinTypeIndex === 0) {
        return this.apy * this.amount / this.price / 12
      } else if (this.coinTypeIndex === 1) {
        return this.apy * this.amount / 12
      }
    },
    coinYearlyEarning: function () {
      if (this.coinTypeIndex === 0) {
        return this.apy * this.amount / this.price
      } else if (this.coinTypeIndex === 1) {
        return this.apy * this.amount
      }
    }
  },
  created () {
    this.post('/user/getprice', {coin_type: 112}).then((res) => {
      if (res.code === 200) {
        this.price = res.data.price
      }
    }).catch((err) => {
      console.log(err)
    })
    this.get('https://sa.coinpayu.com/api/crontab/detailStaking', {stake_id: 3}).then((res) => {
      this.coinData = res.data
    }).catch((err) => {
      console.log(err)
    })
  },
  mounted () {
    let that = this
    this.coinTypeWidth = $('.staking-content-calculator-coin-type-selected div').width()
    $('.staking-content-faq-title').on('click', function () {
      $(this).parent().siblings().find('.staking-content-faq-content').slideUp(200).siblings().find('img').css({'transform': 'rotateZ(-90deg)'})
      if (that.faqIndex === $(this).parent().index()) {
        that.faqIndex = -1
        $(this).find('img').css({'transform': 'rotateZ(-90deg)'})
      } else {
        that.faqIndex = $(this).parent().index()
        $(this).find('img').css({'transform': 'rotateZ(0deg)'})
      }
      $(this).siblings().slideToggle(200)
    })
    $('.staking-content-calculator-coin-type-selected').on('click', function () {
      $(this).siblings().slideToggle(200)
    })
    $('.staking-content-calculator-coin-type-choose').on('click', function () {
      $(this).slideUp(200)
    })
  },
  methods: {
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    changeStaking: function () {
      this.$ChangeStaking()
    },
    replaceAmountInput: function () {
      let arr = []
      let string = this.amountInput.toString().replace(/\D/g, '')
      if (string.replace(/\D/g, '').indexOf('.') !== -1) {
        arr = string.split('.')
        this.amountInput = arr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1].substring(0, 2)
      } else {
        this.amountInput = string.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      }
    },
    seeGuide: function () {
      if (this.stakingGuideDate.length > 1) {
        this.modelShow = true
      } else {
        window.open(this.stakingGuideDate[0].url, '_blank')
      }
    },
    toGuide: function (url) {
      window.open(url, '_blank')
    },
    copyAddress: function (text) {
      this.$copyText(text).then((e) => {
        this.$tip('copy successfully', true)
      }, (e) => {
        console.log(e)
      })
    }
  },
  metaInfo () {
    return {
      title: 'Terra Classic Staking',
      meta: [
        {
          name: 'description',
          content: 'PoS Node allows you to stake your LUNC and recieve rewards directly from the Terra Classic blockchain network. Learn how to stake LUNC the current staking interest, faq,validator fees, rewards calculations and more.'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import url( '../assets/css/staking.css');
</style>



// WEBPACK FOOTER //
// src/pages/Terra.vue